import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Talk, selectCharacter } from './images';

const renderChapter = (chapter) => {
  const talk = chapter.scenarios.find(s => s.scenario_type === 'talk');
  const lesson = chapter.scenarios.find(s => s.scenario_type === 'lesson');
  const lessonClass = lesson ? 'btn' : 'btn hidden';
  const lessonHref = lesson ? lesson.scenario_link : '';
  return (
    <div className="chapter next" key={chapter.chapter_number}>
      <a className={lessonClass} href={lessonHref}>
        <span className="content">
          <span className="chapter-label">Chapter</span>
          <span className="chapter-number">{chapter.chapter_number}</span>
          <span className="chapter-name">{chapter.chapter_title}</span>
        </span>
      </a>
      {talk && (
        <a className="btn talk" href={talk.scenario_link}>
          <img alt="" height="94" src={Talk} width="94" />
        </a>
      )}
    </div>
  );
};

const StoryLessonEpisode = ({ episode }) => {
  if (!episode.chapters) {
    return null;
  }
  const chapters = episode.chapters
    .filter(c => c.chapter_number !== '0' && c.chapter_number !== '99')
    .map(c => renderChapter(c));
  const prologue = episode.chapters.find(c => c.chapter_number === '0');
  const epilogue = episode.chapters.find(c => c.chapter_number === '99');
  const boxClass = `episode-box${episode.episode_number}`;
  const charcterPng = selectCharacter(episode.episode_number);
  const btnStyle = { backgroundImage: `url(${Talk})` };
  return (
    <section className={boxClass} key={episode.episode_number}>
      <div className="container">
        <div className="headline">
          <p className="character">
            <img alt="" height="240" src={charcterPng} width="200" />
          </p>
          <p className="chap_title">
            <small>Episode</small>
            <span className="episode-number">{episode.episode_number}</span>
            {episode.episode_title}
          </p>
        </div>
        <ul className="story">
          {prologue && (
            <a className="btn" href={prologue.scenarios[0].scenario_link}>
              <li style={btnStyle}><span title="en.titles.prologue">{<FormattedMessage id="home.prologue_button" />}</span></li>
            </a>
          )}
          {epilogue && (
            <a className="btn" href={epilogue.scenarios[0].scenario_link}>
              <li style={btnStyle}><span title="en.titles.epilogue">{<FormattedMessage id="home.epilogue_button" />}</span></li>
            </a>
          )}
        </ul>
        {chapters}
      </div>
    </section>
  );
};

StoryLessonEpisode.propTypes = {
  episode: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default StoryLessonEpisode;
